<template>
  <div class="columns is-gapless">
    <div class="column">
      <wysiwyg-editor
        :light="true"
        :tooltip-top="true"
        :model="source.message"
        @change="val => note.message = val"
        class="editr--bottom-toolbar no-toolbar editr--height-small content has-parent-border">
      </wysiwyg-editor>
    </div>
    <div class="actionsOnRow actionsOnRow--vertical">
      <div>
        <button
          type="button"
          class="button is-success"
          @click="save()">
          <span class="icon is-small">
            <i class="fal fa-save"></i>
          </span>
        </button>
      </div>
      <div class="">
        <button
          type="button"
          class="actionsOnRow-btn--hoverIsDanger"
          @click="close()">
          <span class="icon is-small"><i class="fal fa-times"></i></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoteContact',
  props: {
    source: {
      type: Object
    }
  },
  data () {
    return {
      note: {
        message: null
      }
    }
  },
  created () {
    if (this.source) this.note = Object.assign({}, this.source)
    this.openWysiwyg()
  },
  methods: {
    async save () {
      if (this.note.message && this.note.message.length) {
        this.$emit('save', this.note)
      } else if (this.note.pk) {
        let value = await this.$swal({
          title: 'Suppression note',
          text: 'La note ne sera plus consultable.',
          icon: 'warning',
          confirmButtonText: 'Supprimer',
          customClass: {
            confirmButton: 'is-danger'
          }
        })
        if (value && value.dismiss) return false
        if (value) {
          this.$emit('deleteNote', this.note)
        }
      } else {
        this.$toasted.global.danger('La note ne peut être vide')
      }
    },
    close () {
      this.$emit('close', {})
    },
    openWysiwyg () {
      this.$nextTick(() => {
        let wysiElem
        if (this.source) {
          let selection = document.getSelection()
          let range = document.createRange()
          let contenteditable = document.querySelector('div[contenteditable="true"]')

          if (contenteditable.lastChild.nodeType === 3) {
            range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
          } else {
            range.setStart(contenteditable, contenteditable.childNodes.length)
          }
          selection.removeAllRanges()
          selection.addRange(range)
          wysiElem = document.getElementsByClassName('ql-editor ql-blank')
          wysiElem = wysiElem[0]
          wysiElem.setAttribute('contenteditable', 'true')
          wysiElem.focus()
        } else {
          wysiElem = document.getElementsByClassName('ql-editor ql-blank')
          wysiElem = wysiElem[0]
          wysiElem.setAttribute('contenteditable', 'true')
          wysiElem.focus()
        }
      })
    }
  }
}
</script>

<style lang="sass">

</style>
